import React, { useEffect } from 'react'
import verifyWithClearIcon from './img/ic-verify-with-clear.svg'
import {
  useVerifyWithClear,
  VerifyWithClearContent,
} from './VerifyWithClearFailure'
import { setMbiFailedInfo } from './mbiFailedCache'
import { ScreenKey } from '../util'
import { logAmplitudeEvent } from 'utils/amplitudeInit'

const VerifyWithClear = (props) => {
  const { sku } = props
  const { redirectUrl, urlLoaded } = useVerifyWithClear()

  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - Identity Verification', {
      sku,
    })
  }, [sku])

  const onBack = (e) => {
    props.setRemoveEventListener(false)
    props.onBack(e)
  }
  const onNext = () => {
    logAmplitudeEvent('Click: Onboarding - Identity Verification - Start', {
      sku,
    })
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      setMbiFailedInfo({
        unavailableReason: 'Identity',
        unavailableDetail: '',
      })
      return ScreenKey.NOT_ELIGIBLE
    }
  }

  return (
    <VerifyWithClearContent
      {...props}
      icon={verifyWithClearIcon}
      title={'Verify with CLEAR'}
      text={
        'To continue with your eligibility, ACCESS requires you to verify your identity.'
      }
      onNext={onNext}
      onBack={onBack}
      urlLoaded={urlLoaded}
    />
  )
}

export default VerifyWithClear
